import styled, { css } from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { Grid } from '@interstate/components/Grid';
import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const BaseDealHeaderRoot = styled.div<{
    applyDealStatusStyles?: boolean;
}>`
    display: flex;
    justify-content: space-between;
    margin-top: 1.1rem;
    margin-bottom: 1.29rem;

    ${({ applyDealStatusStyles }) =>
        applyDealStatusStyles
            ? `
                flex-wrap: wrap;
                align-items: center;

                @media (max-width: ${BreakPoint.SCREEN_MD_MIN}) {
                    gap: 0.75rem;
                }
            `
            : `
                align-items: center;
            `}

    @media (max-width: ${BreakPoint.SCREEN_MD_MIN}) {
        margin-bottom: 1.64rem;
    }

    @media (max-width: ${BreakPoint.PHONE}) {
        margin-bottom: 1.64rem;
    }
`;

export const DealHeaderRightGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
`;

export const BaseDealHeaderTitle = styled.h1`
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0;
`;

export const compactFieldControlStyles = css`
    #expandable-root:focus {
        outline: 2px solid #005ba8;
    }
    .base-deal-activity-control-custom-label {
        color: #005ba8;
        height: 17px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.25rem;
        margin-bottom: 4px !important;

        svg {
            flex-shrink: 0;
        }

        &:focus-visible {
            outline: 2px solid #005ba8;
            outline-offset: 2px;
            border-radius: 2px;
        }
    }

    // inputs
    .MuiOutlinedInput-root {
        height: 24px !important;
        .MuiOutlinedInput-notchedOutline {
            top: -7px !important;
        }
    }

    // read-only inputs
    .ids-text-input-readonly {
        height: 24px !important;
    }

    // combo-boxes
    .ids-combo-box-root-container {
        height: 24px !important;
        padding-top: 1px;
        .MuiGrid2-root {
            padding-bottom: 0 !important;
            padding-top: 0 !important;
            .ids-combo-box-input-and-chips {
                min-height: 27px !important;
                .ids-combo-box-open-button {
                    padding: 0 !important;
                }
            }
        }
    }

    // horizontal toggles
    .MuiToggleButtonGroup-root {
        height: 28px !important;
    }

    // select fields
    [id^='select-input-options'] {
        position: relative;
        height: 27px;
        padding: 0.4rem 0.5rem;
        margin-top: -2px;
    }
`;

// istanbul ignore next
export const BaseDealContainerRootCompact = styled.div<{
    isDealCentralMultiScenario?: boolean;
    isDealCentralExperience?: boolean;
    theme: InterstateTheme;
}>`
    padding: 0.5rem 0.5rem 1.14rem;
    border-radius: 0.625rem;
    border: 1px solid #b2b2b2;
    display: flex;
    margin-bottom: 0;
    gap: ${({ theme }) => theme.spacing?.(1)};
    flex-direction: ${(props) => (props.isDealCentralMultiScenario ? 'column' : 'row')};
    background-color: ${({ theme }) => theme.palette?.background?.default || '#fff'};
    box-shadow: ${({ theme }) => theme.tokens.BaseShadowLg};
    &.selected {
        background-color: ${({ theme }) => theme.tokens?.BaseColorBlue50};
        border-color: ${({ theme }) => theme.tokens?.BaseColorBlue900};
    }

    @media (max-width: ${BreakPoint.PHONE}) {
        padding: 0.57rem;
    }

    @media (max-width: ${BreakPoint.SMALL}) {
        flex-direction: column;
    }

    @media (max-width: ${BreakPoint.MEDIUM}) {
        flex-direction: ${(props) => (props.isDealCentralExperience ? 'column' : 'row')};
    }

    ${compactFieldControlStyles}
`;

export const BaseDealContent = styled.div<{ isDealCentralMultiScenario?: boolean }>`
    width: 100%;
    flex: ${(props) => (props.isDealCentralMultiScenario ? '0' : '2')};
`;

export const BaseDealVehicleInfo = styled.div<{ isDealCentralMultiScenario?: boolean }>`
    border-bottom: 1px solid #b2b2b2;
    padding-bottom: 0;
    ${({ isDealCentralMultiScenario }) =>
        isDealCentralMultiScenario &&
        css`
            border-bottom: 0;
        `}
`;

export const BaseDealLayoutContainer = styled(Grid)`
    padding: 2.07rem 1.14rem 1.14rem !important;
    @media (max-width: ${BreakPoint.PHONE}) {
        padding: 2.57rem 0.57rem 0.57rem !important;
    }
`;

export const StyledBreakdownLabel = styled.div`
    padding-top: 1rem;
    font-size: 1.14rem;
    padding-left: 1.4rem;
    font-weight: 600;
`;
export const BreakdownContainer = styled(Grid)`
    border-radius: 0.3125rem;
    padding: 0 !important;
    padding-top: 16px !important;

    &.full-width-breakdown-container {
        width: 100%;
    }
    &.breakdown-container {
        width: 100%;
        flex: 1;
    }
`;

export const CompactBreakdownContainer = styled(BreakdownContainer)`
    padding-top: 0.5rem !important;
`;

export const AutoSelectProgramContainer = styled.div<{
    isBaseDealExperience: boolean;
    isDealCentralExperience: boolean;
}>`
    ${({ isBaseDealExperience, isDealCentralExperience }) => `
        margin-top: ${isBaseDealExperience ? '0' : '16px'};
        margin-bottom: ${!isDealCentralExperience ? '8px' : isBaseDealExperience ? '0' : '8px'};
    `}
`;
